<template>
    <span>
        <b-badge :variant="variant">{{ status }}</b-badge>
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            statusPrimary: [
                'ATIVO',
                'ATIVA',
                'SIM',
                'VIGENTE',
                'CADASTRADA',
                'CADASTRADO',
                'OK',
                'PRONTO PARA MIGRAÇÃO',
                'CONTRATO DISTRIBUÍDO',
                'CONTRATO VIGENTE',
                'ADITIVO DISTRIBUÍDO',
                'ADITIVO VIGENTE',
                'NO PRAZO',
                'NADA CONSTA',
                'REGULAR',
                'SUCESSO',
                'ATUALIZADO',
                'APROVADO',
                'VINCULADO A UM PAGAMENTO',
                'APROVADA',
                'PARCELA FIXA',
                'APROVADO',
                'CONVÊNIO VIGENTE',
                'INTEGRADO',
                'PREVISTO'
            ],
            statusInfo: [
                'PAGA',
                'COMPROMETIDO COM SUCESSO',
                'CONVÊNIO APROVADO',
                'EM ABERTO',
                'ENVIO REGISTRADO',
                'AUTORIZADA'
            ],
            statusSuccess: [
                'PROCESSADA',
                'MIGRADO',
                'REQUISIÇÃO',
                'CONFERIDO',
                'CONCLUÍDO',
                'CONCLUÍDA',
                'FINALIZADA',
                'ATA CONCLUIDA',
                'ENCAMINHADO',
                'SEM PENDÊNCIAS',
                'SOLICITAÇÃO APROVADA',
            ],
            statusWarning: [
                'DEVOLVIDA',
                'NÃO CONFERIDO',
                'EM PROCESSAMENTO',
                'FALHA NA MIGRAÇÃO',
                'ERROAPI',
                'ERROINTERNO',
                'SUCESSOCOMRESSALVAS',
                'FALHA NA ATUALIZAÇÃO',
                'ERROSISTEMAREMOTO',
                'DOCUMENTOENTRADAINVALIDA',
                'DOCUMENTOENTIDADENAOENCONTRADA',
                'PARAMETROSINVALIDOS',
                'PARAMETROSNAOSUPORTADOS',
                'SISTEMAREMOTOINDISPONIVEL',
                'TEMPOESGOTADO',
                'TENTATIVASESGOTADAS',
                'LIMITESIMULTANEASATINGIDO',
                'CONSULTAINDISPONIVEL',
                'ACESSONEGADO',
                'FALHAAOREALIZARCONSULTA',
                'PENDENTE',
                'NÃO COMPROMETIDO',
                'EM ANÁLISE',
                'EM PROCESSAMENTO PELO SETOR FINANCEIRO',
                'CONTRATO DISTRIBUÍDO AGUARDANDO INTEGRAÇÃO',
                'INICIADO ADITIVO DE CONTRATO',
                'ADITIVO ASSINADO AGUARDANDO INTEGRAÇÃO',
                'ADITIVO AGUARDANDO JOB DE INTEGRAÇÃO',
                'DEVOLVIDA PARA ANÁLISE',
                'DEVOLVIDA PARA CORREÇÃO',
                'DEVOLVIDO POR FMO',
                'DEVOLVIDO FORA DO PRAZO',
                'ESPECIAL',
                'CONVÊNIO ENCERRADO',
                'NÃO INTEGRADO',
                'ESPECIAL',
                'AGUARDANDO APROVAÇÃO DOS SERVIÇOS/ENTREGAS',
                'AGUARDANDO SETOR FINANCEIRO',
                'AGUARDANDO ANÁLISE',
                'AGUARDANDO ANÁLISE GESTOR'
            ],
            statusSecondary: [
                'INATIVO',
                'INATIVA',
                'NÃO ATUALIZADO',
                'CONVÊNIO ENCERRADO'
            ],
            statusDanger: [
                'NÃO',
                'VENCIDA',
                'VENCIDO',
                'NOK',
                'FALHA PARA MIGRAÇÃO',
                'CONSTA',
                'IRREGULAR',
                'REPROVADO',
                'REPROVADO PELO SETOR FINANCEIRO',
                'REPROVADA',
                'REPROVADO PARA AJUSTE PELO FORNECEDOR',
                'REPROVADO PELO SETOR FINANCEIRO PARA AJUSTE INTERNO',
                'GLOSADO',
                'CANCELADA',
                'SOLICITAÇÃO DEVOLVIDA'
            ],
            statusDark: [
                'CANCELADA',
                'REPROVADA',
                'PRIORITÁRIO',
                'CANCELADA',
                'CANCELADO',
                'ALTERADO',
            ]
        }
    },

    computed: {
        variant() {
            if (
                this.statusPrimary.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'primary'
            } else if (
                this.statusInfo.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'info'
            } else if (
                this.statusSuccess.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'success'
            } else if (
                this.statusWarning.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'warning'
            } else if (
                this.statusSecondary.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'secondary'
            } else if (
                this.statusDanger.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'danger'
            } else if (
                this.statusDark.filter((item) => {
                    return item === this.status
                }).length > 0
            ) {
                return 'dark'
            }
        }
    }
}
</script>
